'use client'

import { cn } from '@/_lib/utils'

import { AOrderProgressBar } from '../../progress-bar/a-order-progress-bar'

type OrderFlowContainerProps = {
	children: React.ReactNode
	className?: string
	containerClassName?: string
	hasProducts?: boolean
	/** Outer background (default matches legacy off-white hero). */
	color?: string
}

/**
 * Max-width content column for order pages (padding, optional extra top offset when cart has lines).
 */
export function OrderFlowContainer({
	children,
	className,
	containerClassName,
	hasProducts = false,
	color = '#fdfbf7'
}: OrderFlowContainerProps) {
	return (
		<div className={cn(className)} style={{ backgroundColor: color }}>
			<div
				className={cn(
					'px-4 md:max-w-[1340px] md:mx-auto pt-[250px] lg:pt-[190px] lg:px-8 pb-16',
					hasProducts && 'pt-[300px]',
					containerClassName
				)}
			>
				{children}
			</div>
		</div>
	)
}

type OrderFlowShellProps = {
	hasProducts: boolean
	children: React.ReactNode
	/** Extra classes on the desktop progress bar root (always includes `mb-8`). */
	progressBarClassName?: string
}

/**
 * Shared chrome: padded container + progress bar + step body.
 */
export function OrderFlowShell({
	hasProducts,
	children,
	progressBarClassName
}: OrderFlowShellProps) {
	return (
		<OrderFlowContainer hasProducts={hasProducts}>
			<AOrderProgressBar className={cn('mb-8', progressBarClassName)} />
			{children}
		</OrderFlowContainer>
	)
}
